import { MessageSearchCriteria, MessageSearchResults } from "../..";
import { RelodeApiError } from "../../../../";
import {
    ActionsUnion,
    createAction,
} from "../../../../components/reducer/actionHelpers";

enum names {
    SEARCH_MESSAGES = "SEARCH_MESSAGES",
    SEARCH_MESSAGES_SUCCESS = "SEARCH_MESSAGES_SUCCESS",
    SEARCH_MESSAGES_FAILURE = "SEARCH_MESSAGES_FAILURE",
    SORT_MESSAGES = "SORT_MESSAGES",
    SET_SEARCH_CRITERIA = "SET_SEARCH_CRITERIA",
    // SEARCH_MESSAGES = "SEARCH_MESSAGES",
    FILTER_MESSAGES = "FILTER_MESSAGES",
    NAVIGATE = "NAVIGATE",
    DESELECT_ALL_MESSAGES = "DESELECT_ALL_MESSAGES",
    SELECT_ALL_MESSAGES = "SELECT_ALL_MESSAGES",
    SET_MESSAGE_CHECKED = "SET_MESSAGE_CHECKED",
    SET_MESSAGE_UNCHECKED = "SET_MESSAGE_UNCHECKED",
    SET_MESSAGES_READ = "SET_MESSAGES_READ",
    SET_MESSAGES_READ_SUCCESS = "SET_MESSAGES_READ_SUCCESS",
    SET_MESSAGES_UNREAD = "SET_MESSAGES_UNREAD",
    SET_MESSAGES_UNREAD_SUCCESS = "SET_MESSAGES_UNREAD_SUCCESS",
}

export default names;
export type MessageFacet = {
    id: string;
    name: string;
    item?: { label: string; value: string };
};
export const creators = {
    search: (criteria: MessageSearchCriteria) =>
        createAction(names.SEARCH_MESSAGES, { criteria }),
    searchSuccess: (results: MessageSearchResults) =>
        createAction(names.SEARCH_MESSAGES_SUCCESS, { results }),
    searchFailure: (error: RelodeApiError) =>
        createAction(names.SEARCH_MESSAGES_FAILURE, { error }),
    navigate: (direction: "next" | "prev") =>
        createAction(names.NAVIGATE, { direction }),
    filter: (facet: MessageFacet) =>
        createAction(names.FILTER_MESSAGES, { facet }),
    sort: (field: string) => createAction(names.SORT_MESSAGES, { field }),
    selectAllMessages: () => createAction(names.SELECT_ALL_MESSAGES),
    selectMessage: (id: number) =>
        createAction(names.SET_MESSAGE_CHECKED, { id }),
    unselectMessage: (id: number) =>
        createAction(names.SET_MESSAGE_UNCHECKED, { id }),
    deselectAllMessages: () => createAction(names.DESELECT_ALL_MESSAGES),
    markSelectedRead: () => createAction(names.SET_MESSAGES_READ),
    markSelectedUnread: () => createAction(names.SET_MESSAGES_UNREAD),
    setSearchCriteria: (criteria: MessageSearchCriteria) =>
        createAction(names.SET_SEARCH_CRITERIA, { criteria }),
};

export type MessageSearchActionTypes = ActionsUnion<typeof creators>;

// export type MessageListingActionTypes_ =
//     | { type: "LOAD_MESSAGES"; searchCriteria?: MessageSearchCriteria }
//     | { type: "LOAD_MESSAGES_SUCCESS"; results: MessageSearchResults }
//     | { type: "LOAD_MESSAGES_FAILURE" }
//     | { type: "SORT_MESSAGES"; field: string }
//     | { type: "SEARCH_MESSAGES"; searchText?: string }
//     | {
//           type: "FILTER_MESSAGES";
//           facet: {
//               id: string;
//               name: string;
//               item?: { label: string; value: string };
//           };
//       }
//     | { type: "CHANGE_PAGE"; pageIndex: number }
//     | { type: "DESELECT_ALL_MESSAGES" }
//     | { type: "SELECT_ALL_MESSAGES" }
//     | { type: "SET_MESSAGE_CHECKED"; messageId: number }
//     | { type: "SET_MESSAGE_UNCHECKED"; messageId: number }
//     | { type: "SET_MESSAGES_READ" }
//     | { type: "SET_MESSAGES_READ_SUCCESS" }
//     | { type: "SET_MESSAGES_UNREAD" }
//     | { type: "SET_MESSAGES_UNREAD_SUCCESS" }
//     | {
//           type: "SET_SEARCH_CRITERIA";
//           box: "inbox" | "sent";
//           searchText?: string;
